<script setup lang="ts">
import { useSessionStore } from '../../../stores';
import { Session } from '../../../types/session';
import Fullscreen from '../../General/Fullscreen.vue';
import StudentPracticeFinished from './StudentPracticeFinished.vue';
import StudentPracticePlaying from './StudentPracticePlaying.vue';
import StudentPracticeWaiting from './StudentPracticeWaiting.vue';

const sessionStore = useSessionStore()
</script>

<template>
    <Fullscreen class="p-3 h-full">
        <StudentPracticeWaiting v-if="!sessionStore.practiceQuizState?.[Session.practice]" />
        <template v-else>
            <StudentPracticeFinished v-if="sessionStore.currentPracticeResult" />
            <StudentPracticePlaying v-else />
        </template>
    </Fullscreen>
</template>